<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="frontmatter" title="Acknowledgments">
<p class="h1" id="ch-3"><span class="right_1" epub:type="pagebreak" id="page_xi" title="xi"><a href="#/text/9780253044174_Contents#ch3"><b>ACKNOWLEDGMENTS</b></a></span></p>
<p class="noindent">This book would not have been possible without the support of Professor Spencer C. Tucker, the editor of Indiana University Press’s Twentieth-Century Battles Series, who showed interest in the subject. Credit is due to the editor Ashley Runyon for showing exceptional patience in the face of delays in the preparation of the book. Special thanks to my research assistant Jane Bryan-Brown and PhD student Moumita Chaudhury for helping me collect materials from various archives in Britain and India. I am grateful to my friends Gavin Rand and Peter Stanley for directing me to important holdings in the United Kingdom and Australia. And of course, Narender Yadav deserves praise for helping me access the Ministry of Defence Historical Section in New Delhi. My thanks to KnowTechInfo for funding some of my research trips. I am grateful to Jennifer Crane for her support while editing the manuscript. And I will not thank my wife because it would never be enough. It goes without saying that any faults in the book are mine alone.<span class="right_1" epub:type="pagebreak" id="page_xii" title="xii"></span></p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780253044174_Acknowledgments.vue?28b3b99d